import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { RichTextArea } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { useIntl, useSelector, statusSuccess } from '@grandvisionhq/state';
import { useRxGlassesConfiguratorContext } from '../../../../context/RxGlassesConfiguratorContext.js';
import '../../../../state/actions.js';
import '../../../../state/add-to-cart/selectors.js';
import '../../../../state/bundles/selectors.js';
import '../../../../state/bundles/reducer.js';
import { getPrescription } from '../../../../state/configurator/selectors.js';
import '../../../../state/configurator/reducer.js';
import '../../../../state/products/selectors.js';
import '../../../../state/products/reducer.js';
import { PrescriptionInformationDrawer } from '../../../components/PrescriptionInformationDrawer/PrescriptionInformationDrawer.js';
import 'classnames';
import { PrescriptionFormLabelDetailsTrigger } from './components/PrescriptionFormLabelDetailsTrigger.js';

const PrescriptionFormLabelDetails = ()=>{
    var ref;
    const { getLabel  } = useIntl();
    const { configuratorDocument  } = useRxGlassesConfiguratorContext();
    const title = getLabel('products.configurator.step.prescription.opticalparams.details');
    const richTextDescription = configuratorDocument === null || configuratorDocument === void 0 ? void 0 : (ref = configuratorDocument.prescriptionStep) === null || ref === void 0 ? void 0 : ref.readDescription;
    const prescription = useSelector(getPrescription);
    if (!statusSuccess(prescription)) {
        // Loading / error states are handled further up the tree
        return null;
    }
    const opticalParameters = prescription.result.parameters;
    const handleClick = ()=>{
        DataLayer.Events.pushDrawerEventToDataLayer({
            siteFeature: 'rxconfigurator',
            interactionType: 'how_to_read_prescription_click'
        });
    };
    return /*#__PURE__*/ React.createElement(PrescriptionInformationDrawer, {
        trigger: /*#__PURE__*/ React.createElement(PrescriptionFormLabelDetailsTrigger, {
            onClick: handleClick,
            title: title
        }),
        title: title,
        "data-t": "prescription-form-drawer"
    }, richTextDescription ? /*#__PURE__*/ React.createElement(RichTextArea, {
        content: richTextDescription,
        isContained: true
    }) : /*#__PURE__*/ React.createElement("div", {
        className: "prescription-form-label-details"
    }, /*#__PURE__*/ React.createElement("dl", {
        "aria-label": title,
        className: "prescription-form-label-details__list"
    }, opticalParameters.map((item, index)=>{
        return /*#__PURE__*/ React.createElement("div", {
            className: 'prescription-form-label-details__item',
            key: index
        }, /*#__PURE__*/ React.createElement("dt", null, /*#__PURE__*/ React.createElement(Heading, {
            component: "h4",
            variant: "subheading1",
            className: "prescription-form-label-details__item--label"
        }, getLabel(`products.glasses.prescription.${item.name}`))), /*#__PURE__*/ React.createElement("dd", {
            className: "prescription-form-label-details__item--text"
        }, getLabel(`products.glasses.prescription.${item.name}.tooltip`)));
    }))));
};

export { PrescriptionFormLabelDetails };
//# sourceMappingURL=PrescriptionFormLabelDetails.js.map
